import { Serializer } from "survey-core";

// Define a custom properties
Serializer.addProperty("rating", {
  name: "midRateDescription",
  type: "string",
  category: "general",
  displayName: "Mid Rate Description"
});
Serializer.addProperty("rating", {
    name: "rateDescriptions",
    type: "array",
    category: "general",
    displayName: "Rate Descriptions"
});

// Custom React component for a single rating item
export default function CustomRatingItem(props) {
  const { item, question, handleOnClick, handleOnMouseDown } = props;
  const isMidRate = item.value === Math.ceil((question.rateMin + question.rateMax) / 2);
  const descriptionIndex = item.value - 1;
  const description = question.rateDescriptions?.[descriptionIndex];

//   return (
//     <div className="custom-rating-item" onClick={() => question.value = item.value}>
//       <span className="sv-rating__item-text">{item.text}</span>
//       {description && <span className="sv-rating__item-description">{description}</span>}
//     </div>
//   );

 // Use the predefined CSS classes directly from the cssClasses object
  const itemClass = question?.css?.rating?.item;
  const inputClass = question.css.itemInput;
  const labelClass = question.css.itemText;

  return (
    <div key={item.id} className="custom-rate-item-container">
      <label 
        onMouseDown={handleOnMouseDown}
        style={question.getItemStyle(item.itemValue, item.highlight)}
        className={question.getItemClass(item.itemValue)}
        onMouseOver={(e) => question.onItemMouseIn(item)}
        onMouseOut={(e) => question.onItemMouseOut(item)}
      >
          <input
            type="radio"
            className="sv-visuallyhidden"
            name={question.name}
            id={item.id}
            value={item.value}
            checked={question.value === item.value}
            onClick={handleOnClick}
            onChange={() => {}}
            aria-required={question.ariaRequired}
            aria-label={question.ariaLabel}
            aria-invalid={question.ariaInvalid}
            aria-describedby={question.ariaDescribedBy}
            // aria-label={description || item.text || item.value}
          />
          <span htmlFor={item.id} aria-hidden="true" className={labelClass}>
            {item.text || item.value}
          </span>
      </label>
      
      {/* Display the custom description below */}
      { description && <div className="rate-description">{description}</div> }
    </div>
  );
}
